import { GET_FIRSTNAME, GET_LASTNAME , GET_ADDRESS , GET_CONTRACT, GET_PHONENUMBER, GET_POWRGUARD, GET_SALESREP, GET_SALESREPEMAIL, GET_SALESTYPE, GET_SITEPLANS, GET_SYSTEMSIZE, GET_ZIPCODE, GET_JOBSTATUS, 
GET_MONITORING, GET_NEM, GET_PERMIT,GET_ROLE, GET_EMAIL, GET_UID, GET_SAVED, GET_CURRENT, GET_ENERGYMONTH, GET_TODAY, GET_LIFETIME, GET_CO2, GET_TREES} from '../Actions/types'




const initialState = {
    firstName: null,
    lastName: null,
    address: null,
    contract: null,
    jobstatus: null,
    monitoring: null,
    nem: null,
    permit: null,
    phonenumber: null,
    powrguard: null,
    role: null,
    salesrepemail: null,
    salestype: null,
    salesrep: null,
    siteplans: null, 
    systemsize: null,
    zipcode: null,
    email: null,
    uid: null,

    saved: null,
    current: null,
    energyMonth: null,
    energyToday: null,
    lifetime: null,
    co2: null,
    trees: null,


}

export default function (state = initialState, action) {
    switch(action.type) {
        case GET_FIRSTNAME: 
       
            return {
            ...state,
               firstName: action.payload
            };
        case GET_LASTNAME: 
            return {
                ...state,
                lastName: action.payload
            };
        case GET_ADDRESS: 
        return {
            ...state,
            address: action.payload
        };
        case GET_CONTRACT: 
        return {
            ...state,
            contract: action.payload
        };
        case GET_JOBSTATUS: 
        return {
            ...state,
            jobstatus: action.payload
        };
        case GET_MONITORING: 
        return {
            ...state,
            monitoring: action.payload
        };
        case GET_NEM: 
        return {
            ...state,
            nem: action.payload
        };
        case GET_PERMIT: 
        return {
            ...state,
            permit: action.payload
        };
        case GET_PHONENUMBER: 
        return {
            ...state,
            phonenumber: action.payload
        };
        case GET_POWRGUARD: 
        return {
            ...state,
            powrguard: action.payload
        };
        case GET_ROLE: 
        return {
            ...state,
            role: action.payload
        };
        case GET_SALESREPEMAIL: 
        return {
            ...state,
            salesrepemail: action.payload
        };
        case GET_SALESTYPE: 
        return {
            ...state,
            salestype: action.payload
        };
        case GET_SALESREP: 
        return {
            ...state,
            salesrep: action.payload
        };
        case GET_SITEPLANS: 
        return {
            ...state,
            siteplans: action.payload
        };
        case GET_SYSTEMSIZE: 
        return {
            ...state,
            systemsize: action.payload
        };
        case GET_ZIPCODE: 
        return {
            ...state,
            zipcode: action.payload
        };
        case GET_EMAIL: 
        return {
            ...state,
            email: action.payload
        };
        case GET_UID: 
        return {
            ...state,
            uid: action.payload
        };

        case GET_SAVED: 
        return {
            ...state,
            saved: action.payload
        };
        case GET_CURRENT: 
        return {
            ...state,
            current: action.payload
        };
        case GET_ENERGYMONTH: 
        return {
            ...state,
            energyMonth: action.payload
        };
        case GET_TODAY: 
        return {
            ...state,
            energyToday: action.payload
        };
        case GET_LIFETIME: 
        return {
            ...state,
            lifetime: action.payload
        };
        case GET_CO2: 
        return {
            ...state,
            co2: action.payload
        };
        case GET_TREES: 
        return {
            ...state,
            trees: action.payload
        };
  
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/FirebaseReducer.js